import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';

const LcElemensRow = ({ currentCurriculum, lcs = [], width = 'min-w-120px max-w-120px', classUlInfo }) => {
  return (
    <>
      {currentCurriculum?.lcElements?.children
        ?.sort((a, b) => b.position - a.position)
        ?.map((item, i) => (
          <TableRow
            className={[
              // "flex flex-nowrap w-full gap-1",
              i === 0 ? 'sticky z-10' : ''
            ].join(' ')}
            key={item._id}
            style={{
              bottom: classUlInfo ? '59px' : '19px'
            }}
          >
            <TableCell
              align='center'
              className={['font-bold sticky left-0px z-10', width].join(' ')}
              children={item?.name}
              style={{
                backgroundColor: item?.secondaryColor,
                color: item?.primaryColor
              }}
            />

            {lcs?.map((lc, index) => {
              return (
                <TableCell
                  align='center'
                  key={`lc-elements-${item._id}-lc-${lc._id}-index-${index}`}
                  style={  lc.lcElements[item._id] ? {
                    backgroundColor: item?.secondaryColor,
                    color: item?.primaryColor
                  }: {}}
                  className={[
                    'min-w-200px w-full text-ellipsis border-l border-muted',
                    lc.lcElements[item._id] ? '' : 'bg-lines'
                  ].join(' ')}
                  children={
                    <Typography className='text-ellipsis text-sm'>{lc.lcElements[item._id]}</Typography>
                  }
                />
              );
            })}
          </TableRow>
        ))}
    </>
  );
};

export default LcElemensRow;
